<template>
<div id="annotation-space" class="container-fluid">
  <div>
    <b-btn variant="outline-info" v-b-popover.hover="'Highlight text to start annotating or click on colored sections to view annotations'" title="Info">
      Info
    </b-btn>
  </div>
  <div v-if="url !== undefined" id="paper" class="col-md-12">
    <highlightable @annotate="onAnnotate">
      <PDFPaper v-on:doneRenderingPDF="renderAnnotations" :src="url" />
    </highlightable>
  </div>
  <template v-if="showAnnotationCreator">
    <div id="annotation-pane">
      <div>
        <button class="btn btn-secondary float-left" @click="togglePane">Close</button>
      </div>
      <h3 style="margin-top: 60px">Creating Annotation for</h3>
      <p style="font-style: italic">{{annotationText | truncate(140, '...')}}</p>
      <Editor :text="annotationText" :range="selectionRange" @annotationCreate="annotationCreate" />
    </div>
  </template>
  <template v-if="showAnnotation">
    <div id="annotation-pane">
      <div>
        <button class="btn btn-secondary float-left" @click="toggleAnnotationPane">Close</button>
      </div>
      <h3 style="margin-top: 60px">Annotation for</h3>
      <p>{{selectedAnnotationText}}</p>
      <div class="vote-div">
        <i class="fas fa-chevron-up" @click="upVote"></i>
        <p>{{ annotationScore }}</p>
        <i class="fas fa-chevron-down" @click="downVote"></i>
      </div>
      <div class="vote-div" v-html="userAnnotation" />
    </div>
  </template>
</div>
</template>

<script>
import PDFPaper from '@/components/PDFPaper.vue';
import Highlightable from '@/components/Highlightable.vue';
import Editor from '@/components/Editor.vue';
import { db } from '@/main';
import firebase from 'firebase';

export default {
  components: {
    PDFPaper,
    Highlightable,
    Editor,
  },
  data() {
    return {
      url: this.getURL(),
      annotations: undefined,
      scale: 1,
      showAnnotationCreator: false,
      showAnnotation: false,
      annotationText: '',
      selectionRange: undefined,
      selectedAnnotation: undefined,
      dataIdToAnnotationMapper: {},
      userAnnotation: '',
      selectedAnnotationText: '',
      scoreAdjustment: 0,
    }
  },
  mounted() {
    window.addEventListener('mouseup', this.onMouseup);
    this.getAnnotations();
  },
  computed: {
    annotationScore: function() {
      var positives = this.selectedAnnotation.upVotes.length;
      var negatives = this.selectedAnnotation.downVotes.length;
      return positives - negatives + this.scoreAdjustment;
    }
  },
  methods: {
    upVote() {
      var annotationRef = db.collection('paperAnnotations')
                            .doc(this.$route.params.paperid)
                            .collection('annotations')
                            .doc(this.selectedAnnotation.annotationId);
      if (!this.selectedAnnotation.upVotes.includes(firebase.auth().currentUser.uid)) {
        this.scoreAdjustment = 1;
      }
      annotationRef.set({
        upVotes: firebase.firestore.FieldValue.arrayUnion(firebase.auth().currentUser.uid),
        downVotes: firebase.firestore.FieldValue.arrayRemove(firebase.auth().currentUser.uid)
      }, {
        merge: true
      })
      mixpanel.track("click", {"name": "up vote annotation"})
    },
    downVote() {
      var annotationRef = db.collection('paperAnnotations')
                            .doc(this.$route.params.paperid)
                            .collection('annotations')
                            .doc(this.selectedAnnotation.annotationId);
      if (this.selectedAnnotation.upVotes.includes(firebase.auth().currentUser.uid) || this.scoreAdjustment === 1) {
        this.scoreAdjustment = -1;
      }
      annotationRef.set({
        upVotes: firebase.firestore.FieldValue.arrayRemove(firebase.auth().currentUser.uid),
        downVotes: firebase.firestore.FieldValue.arrayUnion(firebase.auth().currentUser.uid)
      }, {
        merge: true
      })
      mixpanel.track("click", {"name": "down vote annotation"})
    },
    renderAnnotations() {
      if (this.annotations === undefined) {
        return
      }
      for(var i=0; i < this.annotations.length; i++) {
        var annotation = this.annotations[i]
        var uniqueId = Math.random().toString(36).substring(2)
               + (new Date()).getTime().toString(36);
        var ids = annotation.divIds.map(function(i) {
          return '#' + i
        })
        var selectIds = ids.join(',')
        $(selectIds).attr('data-annotationid', uniqueId);
        $(selectIds).css('background-color', 'blue');
        $(selectIds).addClass('annotatedText')
        $(selectIds).on('mouseenter', function() {
          var annotationID = $(this).data('annotationid');
          $('*[data-annotationid="' + annotationID + '"]').css('background-color', 'red');
          $('*[data-annotationid="' + annotationID + '"]').css('cursor', 'pointer');
        });
        $(selectIds).on('mouseleave', function() {
          var annotationID = $(this).data('annotationid');
          $('*[data-annotationid="' + annotationID + '"]').css('background-color', 'blue');
        });
        this.dataIdToAnnotationMapper[uniqueId] = annotation;
      }
    },
    getAnnotations() {
      var annotations = [];
      db.collection('paperAnnotations')
        .doc(this.$route.params.paperid)
        .collection('annotations')
        .get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            if (doc.data().upVotes.length - doc.data().downVotes.length > -3) {
              annotations.push({
                annotationText: doc.data().annotationText,
                textToBeAnnotated: doc.data().textToBeAnnotated,
                userId: doc.data().userId,
                divIds: doc.data().divIds,
                annotationId: doc.id,
                upVotes: doc.data().upVotes,
                downVotes: doc.data().downVotes,
              })
            }
          });
          this.annotations = annotations;
          console.log(annotations)
      })
    },
    annotationCreate(annotation) {
      this.createAnnotation(annotation);
    },
    onAnnotate(text, range) {
      this.showAnnotationCreator = true;
      this.annotationText = text;
      this.selectionRange = this.getNodesFromRange(range);
      mixpanel.track("click", {"name": "annotation button"})
    },
    getNodesFromRange(range) {
      var _iterator = document.createNodeIterator(
        range.commonAncestorContainer,
        NodeFilter.SHOW_ALL, // pre-filter
        {
          // custom filter
          acceptNode: function (node) {
            return NodeFilter.FILTER_ACCEPT;
          }
        }
      );

      var _nodes = [];
      while (_iterator.nextNode()) {
        if (_nodes.length === 0 && _iterator.referenceNode !== range.startContainer) continue;
        _nodes.push(_iterator.referenceNode);
        if (_iterator.referenceNode === range.endContainer) break;
      }
      return _nodes;
    },
    createAnnotation(annotation) {
      const nodes = this.selectionRange;
      var uniqueId = Math.random().toString(36).substring(2)
               + (new Date()).getTime().toString(36);
      this.dataIdToAnnotationMapper[uniqueId] = annotation
      const startNode = this.selectionRange[0].parentNode
      startNode.className = "annotatedText";
      startNode.setAttribute('data-annotationid', uniqueId)
      for (var i = 0; i < nodes.length; i++) {
        var node = nodes[i];
        if (node.nodeType === 1) {
          node.className = "annotatedText";
          node.setAttribute('data-annotationid', uniqueId)
        }
      }
      $(".annotatedText").on('mouseenter', function() {
        var annotationID = $(this).data('annotationid');
        $('*[data-annotationid="' + annotationID + '"]').css('background-color', 'red');
        $('*[data-annotationid="' + annotationID + '"]').css('cursor', 'pointer');
      });
      $(".annotatedText").on('mouseleave', function() {
        var annotationID = $(this).data('annotationid');
        $('*[data-annotationid="' + annotationID + '"]').css('background-color', 'blue');
      });
    },
    togglePane() {
      this.showAnnotationCreator = false;
      mixpanel.track("click", {"name": "close annotation creator button"})
    },
    toggleAnnotationPane() {
      this.showAnnotation = false;
      mixpanel.track("click", {"name": "close annotation button"})
    },
    getURL() {
      var ref = '';
      // get the document reference from the document id
      db.collection('papers').doc(this.$route.params.paperid).get().then((doc) => {
        ref = doc.data().fileReference;
        firebase.storage().ref().child('submittedPapers/' + ref).getDownloadURL().then((url) => {
          this.url = url;
        });
      });
    },
    onMouseup(e) {
      if (e.target.className === 'annotatedText') {
        e.preventDefault();
        this.showAnnotation = true;
        this.userAnnotation = this.dataIdToAnnotationMapper[e.target.dataset.annotationid].annotationText
        this.selectedAnnotationText = this.dataIdToAnnotationMapper[e.target.dataset.annotationid].textToBeAnnotated
        this.selectedAnnotation = this.dataIdToAnnotationMapper[e.target.dataset.annotationid]
      }
    }
  },
  filters: {
    truncate: function (text, length, suffix) {
      if (text.length > length) {
        return text.substring(0, length) + suffix;
      }
      return text
    }
  }
}
</script>

<style scoped>
#annotation-space {
  display: flex;
  flex-direction: column;
}

#annotation-pane {
  transition: all .6s ease;
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 20px;
  width: 35%;
  position: fixed;
  height: 100%;
  background: white;
  right: 0;
  top: 0;
  border-left: 1px solid black;
  overflow: auto;
}

.help-button {
  border-radius: 20px;
  width: 50px;
}
</style>